import Reveal from "../Reveal";
import { STEPS } from "../../data/content";

export default function HowItWorks() {
    return (
        <section id="how-it-works" className="section-pad bg-white border-y border-line" data-testid="how-it-works-section">
            <div className="container-luxe">
                <Reveal className="mb-14 max-w-2xl">
                    <p className="eyebrow mb-5">How It Works</p>
                    <h2 className="font-serif text-navy text-3xl sm:text-4xl leading-snug">
                        Three steps, <span className="italic text-gold">then the road</span>
                    </h2>
                </Reveal>

                <div className="grid gap-10 md:grid-cols-3 md:gap-8 relative">
                    <div className="hidden md:block absolute top-7 left-[12%] right-[12%] border-t border-dashed border-gold/40" aria-hidden="true" />
                    {STEPS.map((s, i) => (
                        <Reveal key={s.numeral} delay={0.12 * i}>
                            <div className="relative" data-testid={`step-${s.title.toLowerCase()}`}>
                                <span className="relative z-10 inline-flex items-center justify-center h-14 w-14 rounded-full bg-navy text-gold font-serif text-lg border border-gold/40">
                                    {s.numeral}
                                </span>
                                <h3 className="mt-6 font-serif text-navy text-2xl">{s.title}</h3>
                                <p className="mt-3 text-sm font-light leading-relaxed max-w-xs">{s.body}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
